
import { Options, Vue } from "vue-class-component";

import * as echarts from "echarts";
import SideMenu from "../components/WorkBench/SideMenu.vue";

import { dispatchDrawEChart } from "../store/Workbench/actions";
import { readEchartOptions } from "../store/Workbench/getters";

@Options({
  components: {
    SideMenu,
  },
})
export default class Workbench extends Vue {
  public async mounted() {
    await dispatchDrawEChart(this.$store);
    this.drawChart();
  }

  get echartOptions() {
    return readEchartOptions(this.$store);
  }

  public drawChart() {
    this.drawLineChart();
    this.drawPieChart();
  }

  public drawLineChart() {
    const lineChart: HTMLElement = document.getElementById(
      "lineChart"
    ) as HTMLElement;
    const option: any = this.echartOptions.lineChartOption;
    const myChart = echarts.init(lineChart).setOption(option);
    return myChart;
  }

  public drawPieChart() {
    const pieChart: HTMLElement = document.getElementById(
      "pieChart"
    ) as HTMLElement;

    const option: any = this.echartOptions.pieChartOption;

    const myChart = echarts.init(pieChart).setOption(option);
    return myChart;
  }
}
